import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

// Config
import { urls } from "../config/routes";

// Components
import NewCaseTypeDialog from "../components/NewCaseTypeDialog";

const NewCaseFlowContext = createContext();

export const useNewCaseFlow = () => useContext(NewCaseFlowContext);

const NewCaseFlowProvider = ({ children }) => {
  const [params, setParams] = useState(null);
  const history = useHistory();

  const open = (extraParams = {}) => setParams(extraParams);
  const close = () => setParams(null);

  const handleComplete = userCapacity => {
    const search = new URLSearchParams({ ...params, userCapacity }).toString();
    setParams(null);
    history.push({ pathname: urls.createCase, search });
  };

  return (
    <NewCaseFlowContext.Provider value={{ open }}>
      {children}
      {params && (
        <NewCaseTypeDialog onClose={close} onComplete={handleComplete} />
      )}
    </NewCaseFlowContext.Provider>
  );
};

NewCaseFlowProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default NewCaseFlowProvider;
